import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { NextPageWithLayout } from './_app';
import Image from 'next/image';

const PrivacyPolicyPage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>เกี่ยวกับเรา | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={`เกี่ยวกับเรา`}></PageHeader>
        <PageTitleMobile>{`เกี่ยวกับเรา`}</PageTitleMobile>
        <Container
          pt={{
            base: 10,
            md: 14,
          }}
          pb={{
            base: 10,
            md: 20,
          }}
        >
          <SimpleGrid
            columns={{
              base: 1,
              md: 2,
            }}
            columnGap={{
              base: 0,
              md: 10,
            }}
            rowGap={{
              base: 10,
              md: 0,
            }}
          >
            <Box
              pl={{
                base: 0,
                md: 8,
              }}
            >
              <Heading as="h4" fontSize="2xl" color="primary.500" mb={3}>
                เกี่ยวกับเรา
              </Heading>
              <Text mb={5}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัท
                แลมป์ตั้น ไลท์ติ้ง เทคโนโลยี จำกัด ก่อตั้งขึ้นเมื่อปี 2526
                เพื่อดำเนินธุรกิจทั้งเป็นผู้ผลิตหลอดไฟ ภายใต้แบรนด์ชั้นนำต่าง ๆ
                มากกว่า 30 ประเทศทั่วโลก และเริ่มก่อตั้งบริษัท แลมป์ตั้น
                ไลท์ติ้ง (2001) เมื่อปี 2544 เพื่อจัดจำหน่ายหลอดไฟ
                อุปกรณ์ส่องสว่างและอุปกรณ์ไฟฟ้าในประเทศไทย ภายใต้แบรนด์
                “แลมป์ตั้น”
              </Text>
              <Text>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ตลอดระยะเวลาที่ผ่านมา
                บริษัทฯ ได้ทุ่มเทแรงกายแรงใจมุ่งมั่นผลิต
                ตรวจสอบสินค้าและให้บริการที่มากด้วยคุณภาพ
                เพื่อตอบรับต่อความพึงพอใจสูงสุดของลูกค้า
                และด้วยความอุตสาหะตั้งมั่นในการพัฒนาศักยภาพของบุคลากรทั้งองค์กร
                เพื่อให้ได้สินค้าที่มีคุณภาพ
                ขับเคลื่อนสิ่งแวดล้อมและพัฒนาก้าวตามนวัตกรรมใหม่อยู่เสมอ
              </Text>
            </Box>
            <Box>
              <Image
                src="/pages/image-about-us.png"
                width={500}
                height={500}
                alt="about us image"
              />
            </Box>
          </SimpleGrid>
        </Container>
      </Box>
    </>
  );
};

PrivacyPolicyPage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common'])),
    },
  };
},
sessionOptions);

export default PrivacyPolicyPage;
